// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingDots_loading__VKAL7","spacer":"LoadingDots_spacer__RnhJD","blink":"LoadingDots_blink__fpRfa"};